import { render, staticRenderFns } from "./RentPage.vue?vue&type=template&id=28c9994b&scoped=true&"
import script from "./RentPage.vue?vue&type=script&lang=js&"
export * from "./RentPage.vue?vue&type=script&lang=js&"
import style0 from "./RentPage.vue?vue&type=style&index=0&id=28c9994b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c9994b",
  null
  
)

export default component.exports